import React, { useState } from "react";
import {
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
  Backdrop,
  CircularProgress,
  Box,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@material-ui/core";
import { useNotification } from "../../hooks/useNotification";
import uploadPictureLogo from "../../images/png/upload-picture.png";
import useStyles from "../../themes/style.js";
import { jwtDecode } from "jwt-decode";
import sample_candidates from "../../images/files/sample_candidates.xlsx";
import excel_icon from "../../images/svg/excel-icon.svg";
import CloseIcon from "@material-ui/icons/Close";
import axios from "axios";

const UploadExistingCandidates = ({ userDetails }) => {
  const classes = useStyles();
  const token = localStorage.getItem("token");
  const decode = jwtDecode(token);
  const [existingConfirmOpen, setExistingConfirmOpen] = useState(false);
  const [existingOpen, setExistingOpen] = React.useState(false);

  const [uploadStatus, setUploadStatus] = useState("");
  const [uploadFile, setUploadFile] = useState([]);
  const [loader, setLoader] = useState(false);

  const handleNotificationCall = useNotification();

  //   function handleExistingConfirm() {
  //     if (uploadFile && uploadFile.name) {
  //       setExistingConfirmOpen(true);
  //       handleExistingClose();
  //     } else {
  //       handleNotificationCall("error", "No file uploaded");
  //     }
  //   }

  const handleExistingClose = () => {
    setExistingOpen(false);
  };
  const handleExistingConfirmClose = () => {
    setExistingConfirmOpen(false);
  };

  const handleExistingUpload = () => {
    try {
      setLoader(true);
      if (!uploadFile && !uploadFile.name) {
        handleNotificationCall("error", "No file uploaded");
        return;
      }
      const FormData = require("form-data");
      const data = new FormData();
      data.append("backup", uploadFile);

      const response = axios.post(
        `${process.env.REACT_APP_SERVER}admin/uploadExistingCandidates`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: token,
          },
        },
      );
      setLoader(false);

      if (response.data.status === true) {
        handleNotificationCall("success", response.data.message);
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  return (
    <Card className={classes.root}>
      <CardContent className={classes.root}>
        <Grid container direction="row" spacing={2}>
          <Grid item xs={12} sm={6}>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12}>
                <Typography variant="subtitle1">
                  Upload existing candidates
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Box
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  alignItems="center"
                  width="100%"
                  mt={2}
                  gridGap={10}
                >
                  {/* Drag and Drop Zone */}
                  <Paper
                    variant="outlined"
                    style={{
                      width: "100%",
                      padding: "20px",
                      border: "2px dashed #A6AEBF",
                      background: "#f9f8f8",
                      textAlign: "center",
                      marginRight: "10px",
                    }}
                  >
                    <img
                      src={excel_icon}
                      style={{ width: "150px", height: "150px" }}
                      width="100%"
                      alt="excel-icon"
                    />

                    {uploadFile && (
                      <Typography variant="body2" color="secondary">
                        {uploadFile?.name}
                      </Typography>
                    )}
                    <Typography
                      variant="body2"
                      style={{
                        color: "#758694",
                        margin: "15px 0px",
                      }}
                    >
                      Sample excel format to upload your data (Only then Vendor
                      / Freelancer can check duplicate)
                      <br />
                      <a href="" download>
                        Click Here
                      </a>
                    </Typography>
                    <Typography
                      variant="body2"
                      style={{
                        fontStyle: "italic",
                        color: "#758694",
                        margin: "15px 0px",
                      }}
                    >
                      (.XLSX Formats Only)
                    </Typography>
                    {!uploadFile ? (
                      <Box display="flex" flexDirection="column" gridGap={10}>
                        <Box display="flex" gridGap={10}>
                          <Button
                            variant="contained"
                            size="small"
                            onClick={() => setUploadFile([])}
                          >
                            Cancel
                          </Button>
                          <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            disabled={!uploadFile}
                            onClick={handleExistingUpload}
                          >
                            Save
                          </Button>
                        </Box>
                      </Box>
                    ) : (
                      <Button
                        variant="contained"
                        color="primary"
                        component="label"
                      >
                        Upload Excel
                        <input
                          type="file"
                          hidden
                          style={{ display: "none" }}
                          onChange={(e) => {
                            setUploadFile(e.target.files[0]);
                          }}
                          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        />
                      </Button>
                    )}
                  </Paper>
                </Box>
              </Grid>
              <Grid item xs={12}></Grid>
            </Grid>
          </Grid>
        </Grid>
        <Dialog
          onClose={handleExistingClose}
          aria-labelledby="dialog-title"
          open={existingOpen}
          width="md"
          maxWidth="md"
          PaperProps={{ style: { width: "100%" } }}
        >
          <DialogTitle className={classes.digTitle}>
            <div className={classes.center}>
              <Typography
                variant="subtitle2"
                className={classes.digColor + " " + classes.digCenter}
              >
                Upload existing candidates
              </Typography>
              <div className={classes.drawerClose}>
                <CloseIcon
                  className={classes.digClose}
                  size="14px"
                  onClick={handleExistingClose}
                />
              </div>
            </div>
          </DialogTitle>
          <DialogContent>
            <Grid className={classes.center}>
              <a href={sample_candidates} className={classes.aLink} download>
                Sample excel format to upload your data (Only then Vendor /
                Freelancer can check duplicate)
              </a>
            </Grid>

            <Grid className={classes.filterGap + " " + classes.center}>
              <input
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                className={classes.input}
                id="icon-button-csv"
                type="file"
                style={{ display: "none" }}
                onChange={(e) => {
                  setUploadFile(e.target.files[0]);
                }}
              />
              <label htmlFor="icon-button-csv">
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  aria-label="upload Backup"
                  component="span"
                >
                  Upload Excel
                </Button>
              </label>
            </Grid>
            <Grid className={classes.center + " " + classes.button}>
              <Typography variant="inherit" className={classes.lineBreak}>
                {uploadFile?.name}
              </Typography>
            </Grid>

            <Grid className={classes.sendWhatsapp}>
              <Button variant="contained" color="primary" size="small">
                Submit
              </Button>

              <Button
                variant="contained"
                size="small"
                color="secondary"
                onClick={handleExistingClose}
              >
                Close
              </Button>
            </Grid>
          </DialogContent>
        </Dialog>

        <Dialog
          onClose={handleExistingConfirmClose}
          aria-labelledby="dialog-title"
          open={existingConfirmOpen}
          width="md"
          PaperProps={{
            style: {
              width: "100%",
            },
          }}
        >
          <DialogTitle className={classes.digTitle}>
            <div className={classes.center}>
              <Typography
                variant="subtitle2"
                className={classes.digColor + " " + classes.digCenter}
              >
                Confirmation
              </Typography>
              <div className={classes.drawerClose}>
                <CloseIcon
                  className={classes.digClose}
                  size="14px"
                  onClick={handleExistingConfirmClose}
                />
              </div>
            </div>
          </DialogTitle>
          <DialogContent>
            <Typography variant="subtitle2" className={classes.center}>
              Are you sure?
            </Typography>

            <Grid className={classes.sendWhatsapp}>
              <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={(e) => {
                  handleExistingUpload();
                }}
              >
                Yes
              </Button>

              <Button
                variant="contained"
                size="small"
                color="secondary"
                onClick={handleExistingConfirmClose}
              >
                No
              </Button>
            </Grid>
          </DialogContent>
        </Dialog>

        <Backdrop className={classes.backdrop} open={loader}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </CardContent>
    </Card>
  );
};

export default UploadExistingCandidates;
